export function isValidUKPostcodeFormat(postcode: string): boolean {
  if (postcode == null || postcode === '') {
    return false;
  }

  const postcodePattern = /^[A-Z][A-Z]?[0-9][0-9]?[A-Z]?\s*(\d[A-Za-z]{2})$/;

  return postcodePattern.test(postcode.trim());
}
